import template from "./form-selector.html";
import "./form-selector.less";
import hotkeyConfigs from "../../services/hotkeyConfig";
import { EVENT_NEW_FORM } from "constants.js";

// formSelector
export function controller(appState, $uibModal, hotkeys, eventBus, $scope) {
	const ctrl = this;

	ctrl.$onInit = init;
	ctrl.onInit = init;
	ctrl.appState = appState;
	ctrl.openFormSelectorModal = openFormSelectorModal;

	function init() {
		ctrl.isCollapsed = true;
		ctrl.form = appState.forms.selected;
		ctrl.showSwitcher = appState.forms.items.length > 1;
		
		if(ctrl.form === undefined) {
			openFormSelectorModal();
		}
		else {
			ctrl.logo = ctrl.form.Agency.Logo ?? ctrl.form.nomenclature.LogoUrl;
		}

		if(ctrl.showSwitcher) {
			hotkeys.add(hotkeyConfigs.GLOBAL.OPEN_FORM_SWITCHER(() => { openFormSelectorModal(); }));
		}

		eventBus.register(
			EVENT_NEW_FORM,
			() => {
				init();
			},
			$scope
		);
	}
	function openFormSelectorModal() {
		$uibModal.open({
			component: "form-selector-modal",
			size: "md"
		});
	}
}
export default angular
	.module("vesl.components.form-selector", [])
	.component("formSelector", {
		template,
		controller
	}).name;
